import { render, staticRenderFns } from "./ShiftsDropdown.vue?vue&type=template&id=288bc8da&scoped=true&"
import script from "./ShiftsDropdown.vue?vue&type=script&lang=js&"
export * from "./ShiftsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsDropdown.vue?vue&type=style&index=0&id=288bc8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288bc8da",
  null
  
)

export default component.exports